<template>
    <PendingPayments></PendingPayments>
</template>
<script>
    import PendingPayments from '@/components/EmployeePendingPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            PendingPayments
        }
    }
</script>